import { useState } from "react";
import { useReducedMotion } from "framer-motion";

/* Wiederverwendbarer Robbie-Hero-Clip: autoplay/muted/loop/playsInline, Poster als Fallback,
   bei prefers-reduced-motion oder Ladefehler nur das Standbild – ohne Text-Overlay.
   Die Box (Größe, Seitenverhältnis, Rundung, Position) steuert die aufrufende Seite über className. */
export const RobbieClip = ({ src, cdn, poster, className = "", objectPosition = "center", testId }) => {
  const reduce = useReducedMotion();
  const [failed, setFailed] = useState(false);
  return (
    <div className={`overflow-hidden bg-[#0b0b0b] ${className}`} data-testid={testId}>
      <img
        src={poster}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ objectPosition }}
        data-testid={testId ? `${testId}-poster` : undefined}
      />
      {!reduce && !failed && (
        <video
          className="absolute inset-0 h-full w-full object-cover"
          style={{ objectPosition }}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={poster}
          onError={() => setFailed(true)}
          aria-hidden="true"
          data-testid={testId ? `${testId}-video` : undefined}
        >
          <source src={src} type="video/mp4" />
          {cdn && <source src={cdn} type="video/mp4" />}
        </video>
      )}
    </div>
  );
};
